<script>
export default {
  name: 'spotify',
  props: ['spotifyTitle', 'playlistLink', 'bgImg', 'description'],
  data() {
    return {};
  },
};
</script>

<template>
  <div
    class="ctpx-cover-sec spotify-sec"
    :style="[
      bgImg
        ? { backgroundImage: 'url(' + bgImg + ')' }
        : {
            backgroundImage:
              'url(https://cdn.shopify.com/s/files/1/0281/7544/files/Spotify-bg.png)',
          },
    ]"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-7">
          <img
            src="https://cdn.shopify.com/s/files/1/0281/7544/files/Spotify_Logo.svg"
            class="spot-logo"
          />
          <h3 class="display-1">{{ spotifyTitle }}</h3>
          <p>{{ description }}</p>
          <a :href="playlistLink" target="_blank" class="btn btn-white"
            >Listen on Spotify</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
